import { useState } from "react";
import { useNavigate } from "react-router-dom"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { stopImpersonation } from "helpers/impersonation_helper";
import { useTranslation } from "react-i18next";

const Logout = () => {
    const { t } = useTranslation();
    const history = useNavigate();
    const [modals, setModals] = useState({ logout: false });

    const toggleModal = (modalName: keyof typeof modals, state?: boolean) => {
        setModals((prev) => ({ ...prev, [modalName]: state ?? !prev[modalName] }));
    };


    const clicLogout = () => {
        stopImpersonation();
        sessionStorage.removeItem('authUser');
        history('/login');
    }

    return (
        <>
            <div className="ms-1 header-item d-none d-sm-flex">
                <Button
                    onClick={() => toggleModal('logout')}
                    type="button"
                    className="btn btn-icon btn-topbar btn-ghost-primary rounded-circle light-dark-mode">
                    <i className="ri-logout-box-line fs-22"></i>
                </Button>
            </div>

            <Modal isOpen={modals.logout} toggle={() => toggleModal('logout')} size="md" keyboard={false} backdrop="static" centered>
                <ModalHeader toggle={() => toggleModal('logout')}>{t("auth.logout")}</ModalHeader>
                <ModalBody>
                    {t("auth.logoutConfirm")}
                </ModalBody>
                <ModalFooter>
                    <Button className="farm-secondary-button" onClick={() => toggleModal('logout', false)}>{t("common.button.cancel")}</Button>
                    <Button className="farm-primary-button" onClick={clicLogout}>
                        {t("auth.logout")}
                    </Button>
                </ModalFooter>
            </Modal>
        </>

    )
}

export default Logout;